<footer class="mt-20">
    <footer-nav class="d-block w-100 pl-100 pl-20-sm pr-100 pr-20-sm ff-roboto pb-10 pt-40"></footer-nav>
    <footer-info class="d-block w-100 pl-100 pl-20-sm pr-100 pr-20-sm ff-roboto pb-10 pt-40"></footer-info>
</footer>